import { Button } from '@/components/ui/button';
import React from 'react';
import EmptyScreenIcon from '@/assets/emptyScreenIcon.png';

interface EmptyStateScreenProps {
    message: string;
}

const EmptyStateScreen: React.FC<EmptyStateScreenProps> = ({message}) => {
    return (
        <div className="h-full">
            <div className="bg-beige-periwinkle h-full flex justify-center flex-col items-center">
                <img src={EmptyScreenIcon} className="h-48 w-80" alt="No Document Found Icon" />
                <p className="text-heading text-charcoal-100 font-p22Mackinac font-normal mt-8">
                    There is nothing to {message || 'review'} yet.
                </p>
                <p className="text-2xl text-charcoal-70 font-inter font-normal leading-8">
                    Please check back later or try reloading the page.
                </p>
                <Button className="bg-iris-100 hover:bg-iris-160 mt-12" onClick={() => window.location.reload()}>
                    Refresh
                </Button>
            </div>
        </div>
    );
};

export default EmptyStateScreen;
